export default __webpack_public_path__ + "static/media/money2.6dfd29c6.svg";